import { createFileRoute, notFound } from "@tanstack/react-router";

const AI_SANDBOX_DESCRIPTION =
  "Local QA surface for Glider AI composer, asset mentions, and hydrated assistant UI.";
const AI_SANDBOX_TITLE = "AI Sandbox | Glider";

export const Route = createFileRoute("/ai-sandbox")({
  beforeLoad: () => {
    if (!(import.meta.env.DEV || import.meta.env.MODE === "test")) {
      throw notFound();
    }
  },
  head: () => ({
    meta: [
      { title: AI_SANDBOX_TITLE },
      { content: AI_SANDBOX_DESCRIPTION, name: "description" },
      { content: "noindex, nofollow", name: "robots" },
    ],
  }),
});
